<template>
  {{#unless @isSwapping}}
    {{#if @destinationElement}}
      {{#in-element @destinationElement insertBefore=null}}
        {{yield}}
      {{/in-element}}
    {{else}}
      {{yield}}
    {{/if}}
  {{/unless}}
</template>
